import {
    GET_ADMINS_REQUESTED,
    GET_ADMINS_SUCCESS,
    GET_ADMINS_FAILED,
    ADD_ADMIN_REQUESTED,
    ADD_ADMIN_SUCCESS,
    ADD_ADMIN_FAILED,
    UPDATE_ADMIN_REQUESTED,
    UPDATE_ADMIN_SUCCESS,
    UPDATE_ADMIN_FAILED,
    DELETE_ADMIN_REQUESTED,
    DELETE_ADMIN_SUCCESS,
    DELETE_ADMIN_FAILED,
} from './types';

export const getAdminsRequested = () => ({
    type: GET_ADMINS_REQUESTED,
});

export const getAdminsSuccess = (admins) => ({
    type: GET_ADMINS_SUCCESS,
    payload: admins,
});

export const getAdminsFailed = (error) => ({
    type: GET_ADMINS_FAILED,
    payload: error,
});

export const addAdminRequested = (admin) => ({
    type: ADD_ADMIN_REQUESTED,
    payload: admin,
});

export const addAdminSuccess = (admin) => ({
    type: ADD_ADMIN_SUCCESS,
    payload: admin,
});

export const addAdminFailed = (error) => ({
    type: ADD_ADMIN_FAILED,
    payload: error,
});

export const updateAdminRequested = (admin) => ({
    type: UPDATE_ADMIN_REQUESTED,
    payload: admin,
});

export const updateAdminSuccess = (admin) => ({
    type: UPDATE_ADMIN_SUCCESS,
    payload: admin,
});

export const updateAdminFailed = (error) => ({
    type: UPDATE_ADMIN_FAILED,
    payload: error,
});

export const deleteAdminRequested = (id) => ({
    type: DELETE_ADMIN_REQUESTED,
    payload: id,
});

export const deleteAdminSuccess = (data) => ({
    type: DELETE_ADMIN_SUCCESS,
    payload: data,
});

export const deleteAdminFailed = (error) => ({
    type: DELETE_ADMIN_FAILED,
    payload: error,
});
